<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fmKGYG/tc-custom/9781571317735.jpg?1704717834393" alt="This image is the cover for the book 2 A.M. in Little America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">2 A.M. in Little America
      </h1>
      <p class="bookDescription body article font2">
        <b>As Americans flee widespread civil conflict, one young refugee ekes out a living in a suspenseful, darkly comic novel: “An important writer in every sense.” —David Foster Wallace</b><br/><br/><i>An </i>Esquire<i> “Best Book of Spring 2022” </i><br/><br/><i>A </i>Literary Hub<i> “Most Anticipated Book of 2022” </i><br/><br/><i>A </i>San Francisco Chronicle<i> “Most Anticipated Novel of 2022”</i><br/><br/>In the future, sweeping civil disorder has forced America’s young people to flee its borders into an unwelcoming world. One such American is Ron Patterson, who finds himself on distant shores, working as a repairman and sharing a room with other refugees. In an unnamed city wedged between ocean and lush mountainous forest, Ron can almost imagine a stable life for himself. Especially when he makes the first friend he’s had in years—a mysterious migrant named Marlise, who bears a striking resemblance to a onetime classmate.<br/><br/>Nearly a decade later—after anti-migrant sentiment has put their whirlwind intimacy and asylum to an end—Ron is living in “Little America,” an enclave of migrants in one of the few countries still willing to accept them. Here, among reminders of his past life, he again begins to feel that he may have found a home. He adopts a stray dog, observes his neighbors, and lands a new repairman job that allows him to move through the city quietly. But this newfound security, too, is quickly jeopardized, as resurgent political divisions threaten the fabric of Little America. Tapped as an informant against the rise of militant gangs and contending with the appearance of a strangely familiar woman, Ron is suddenly on dangerous and uncertain ground.<br/><br/>Brimming with mystery, suspense, and Ken Kalfus’s distinctive comic irony, <i>2 A.M. in Little America</i> poses questions vital to the current moment: What happens when privilege is reversed? Who is watching and why? How do tribalized politics disrupt our ability to distinguish what is true and what is not? This is a story for our time—gripping, unsettling, prescient—by an acclaimed National Book Award finalist.<br/><br/>“My favorite book by one of America’s great living writers.” —Jonathan Safran Foer<br/><br/>“A provocative dystopian story . . . takes hold of the reader.” —<i>Publishers Weekly</i><br/><br/>“A highly readable, taut novel.” —<i>The New York Times Book Review</i><br/><br/>“One of contemporary literature’s best-kept secrets.” —<i>Esquire</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ken Kalfus
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Milkweed Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?85663882